<template>
  <q-menu
    bordered
    side="right"
    overlay
  >
    <q-list>
      <q-item
        v-close-popup
        clickable
        @click.stop="$editModel(model)"
      >
        <q-item-section avatar>
          <q-icon name="filter_alt" />
        </q-item-section>
        <q-item-section>
          Filter to {{ model.name }}
        </q-item-section>
      </q-item>

      <q-item
        v-close-popup
        clickable
        @click.stop="$editModel(model)"
      >
        <q-item-section avatar>
          <q-icon name="not_interested" />
        </q-item-section>
        <q-item-section>
          Exclude {{ model.name }}
        </q-item-section>
      </q-item>

      <q-separator />

      <q-item
        v-close-popup
        clickable
        @click.stop="$editModel(model)"
      >
        <q-item-section avatar>
          <q-icon name="search" />
        </q-item-section>
        <q-item-section>
          Drill Down
        </q-item-section>
      </q-item>

      <q-item
        v-close-popup
        clickable
        @click.stop="$editModel(model)"
      >
        <q-item-section avatar>
          <q-icon name="zoom_out_map" />
        </q-item-section>
        <q-item-section>
          Zoom Out
        </q-item-section>
      </q-item>

      <q-separator />

      <q-item
        v-close-popup
        clickable
        @click.stop="$editModel(model)"
      >
        <q-item-section avatar>
          <q-icon name="edit" />
        </q-item-section>
        <q-item-section>
          Edit {{ model.name }}
        </q-item-section>
      </q-item>
    </q-list>
  </q-menu>
</template>

<script>

export default {
  name: 'ModelModelMenu',
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      editing: false
    }
  },
  methods: {
  }
}
</script>
